/**
 * useTrackPageView — fire an intelligence event once a page mounts.
 * Optional `entity_type` + `entity_id` so it works for article pages,
 * category pages, RFS pages etc.
 *
 * Consent-gated automatically (delegates to trackIntel which checks).
 */
import { useEffect } from "react";
import { trackIntel } from "@/lib/analytics";

export default function useTrackPageView(event = "page_view", meta = {}) {
  useEffect(() => {
    trackIntel(event, meta);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, meta?.entity_type, meta?.entity_id]);
}
